import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import {
  GetInspectionGroupList,
  InspectionGroup,
} from "interfaces/models/inspectionGroup";
import { axiosECS } from "services/baseAxios";

const pathV2 = PATH_API.INSPECTION_GROUP;

const getInspectionGroupList = async (
  params?: GetInspectionGroupList
): Promise<ApiResponse<InspectionGroup[]>> => {
  const { shouldCache, ...other } = params ?? {};
  const data = await axiosECS.get(pathV2, {
    params: { ...other, shouldCache, paging: "cursor" },
  });

  return data;
};

const getInspectionGroupById = async (
  id: string,
  shouldCache?: boolean
): Promise<ApiResponse> => {
  return axiosECS.get(`${pathV2}/${id}`, { params: { shouldCache } });
};

const createInspectionGroup = async (
  inspectionGroup: InspectionGroup
): Promise<ApiResponse> => {
  return axiosECS.post(pathV2, inspectionGroup);
};

const updateInspectionGroup = async (
  inspectionGroup: InspectionGroup
): Promise<ApiResponse> => {
  return axiosECS.patch(pathV2, inspectionGroup);
};

const deleteInspectionGroup = async (
  ids: string[]
): Promise<ApiResponse<string[]>> => {
  return axiosECS.delete(pathV2, {
    data: { ids },
  });
};

export const InspectionGroupApi = {
  getInspectionGroupList,
  getInspectionGroupById,
  createInspectionGroup,
  updateInspectionGroup,
  deleteInspectionGroup,
};
